const message = "Cannot read properties of undefined (reading 'some')"

const actions = new Set([
  'Back',
  'Next',
  'Save Design',
  'Flip',
  'Flip Card',
  'Front',
  'Edit Front',
  'Edit Back',
  'Magic writer',
])

export function editorDiagnosticStep(path: string) {
  return path.match(/^\/v2\/design\/[^/]+\/(front|inside|review)$/)?.[1] ?? null
}

/** Fixed action names only; never retain DOM, card contents or URL parameters. */
export function createArraySomeErrorDiagnostics(now = () => performance.now()) {
  const history: { action: string; time: number }[] = []
  let lastReport = -Infinity
  let reports = 0
  return {
    record(action: string) {
      if (!actions.has(action)) return
      const time = now()
      const previous = history.at(-1)
      if (previous?.action === action && time - previous.time < 250) return
      history.push({ action, time })
      if (history.length > 12) history.shift()
    },
    enrich<T extends { event: string; properties: Record<string, unknown> }>(
      event: T,
      context: { step: string | null; buildId: string; embedded: boolean },
    ): T {
      if (event.event !== '$exception' || !context.step) return event
      const exceptions = event.properties.$exception_list
      if (
        !Array.isArray(exceptions) ||
        !exceptions.some(
          (item) => item?.type === 'TypeError' && item?.value === message,
        )
      )
        return event
      const time = now()
      // Enrich one report per burst without dropping any SDK exception events.
      if (reports >= 3 || time - lastReport < 30_000) return event
      reports++
      lastReport = time
      return {
        ...event,
        properties: {
          ...event.properties,
          gcb_some_error_context: {
            step: context.step,
            build_id: context.buildId,
            embedded: context.embedded,
            recent_actions: history
              .filter((item) => time - item.time < 30_000)
              .map((item) => ({
                action: item.action,
                age_ms: Math.round(time - item.time),
              })),
          },
        },
      }
    },
  }
}
